<!-- <section class="page-wrapper text-center">
    <div class="logo mb-2em">
        <img src="../../assets/images/sb.svg" alt="logo">
    </div>
    <div class="title-block">
        <h2>Starbucks</h2>
        <p>Inspiring and nurturing the human spirit–one person, one cup and one neighborhood at a time.</p>
    </div>
    <div class="splash-block">
        <img src="../../assets/images/splash_image.png" alt="splash_image">
    </div>
</section> -->
<div class="wrapper">
    <section class="page-wrapper text-center">
        <div class="logo mb-2em">
            <img src="../../assets/images/sb.svg" alt="logo">
        </div>
        <div class="title-block">
            <h2>Starbucks</h2>
            <p>Inspiring and nurturing the human spirit–one person, one cup and one neighborhood at a time.</p>
        </div>
        <div class="splash-block">
            <img src="../../assets/images/splash_image.png" alt="splash_image">
        </div>
    </section>
</div>